<template>
  <div>
    <c-table
      ref="table"
      title="물질별 위험도 추정"
      :columns="grid.columns"
      :gridHeight="setheight"
      :data="process.charmEstimationScenarios"
      :merge="grid.merge"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :editable="editable&&!disabled"
      @table-data-change="tableDataChange"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-update-btn 
            name="updateBtn"
            :data="estimationUpdateBtnData"
            :btnEditable="estimationBtnEditable"
            :flagCondition="flagCondition"
            @back="back"
          />
          <c-btn 
            v-if="editable&&!disabled" 
            :isSubmit="isSave"
            :url="saveUrl"
            :param="process.charmEstimationScenarios"
            mappingType="PUT"
            label="저장" 
            icon="save"
            @beforeAction="saveScenario"
            @btnCallback="saveScenarioCallback" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'charm-risk-estimation',
  props: {
    process: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정명
        ramProcessAssessStepCd: '',  // 평가진행상태
        processExplainFeature: '',  // 공정 특징 설명
        assessDeptCd: '',  // 평가 부서 코드
        assessUserId: '',  // 평가 담당자
        assessUserName: '',  // 평가 담당자
        workCycleCd: null,  // 작업발생주기코드
        workCycleName: '',  // 작업발생주기
        workingTime: 0,  // 작업시간(1회)
        ramMatrixId: '',
        temperature: null,
        workMeasurementPlanId: '',
        measPlanContent: '',
        estimationFlag: '',
        charmResultScenarios: [],
        charmEstimationScenarios: [],
      }),
    },
    param: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',
        ramStepCd: '',
      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
    estimationUpdateBtnData: {
      type: Object,
      default: () => ({
        title: '추정',
        flag: false,
        research: '',
      }),
    },
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'mdmChemMaterialId' },
        ],
        columns: [],
        data: [],
        height: '600px'
      },
      volumnItems: [],
      editable: true,
      isSave: false,
      listUrl: '',
      saveUrl: '',
      resultUpdateUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    disabled() {
      return (!(this.param.ramStepCd === 'RCRS00005' || this.param.ramStepCd == 'RCRS00010') 
        || this.process.ramProcessAssessStepCd === 'RPA0000005' 
        || this.process.estimationFlag === 'Y') && !this.estimationUpdateBtnData.flag
    },
    setheight() {
      let pxRemove = this.height.replace('px', '');
      return this.height && this.height.indexOf('px') > -1 && !isNaN(pxRemove) ? (Number(pxRemove) - 130) + 'px' : '500px'
    },
    estimationBtnEditable() {
      return this.editable 
        && this.param.ramStepCd === 'RCRS00010' 
        && this.process.estimationFlag === 'Y'
        && this.process.ramProcessAssessStepCd !== 'RPA0000005'
    },
    flagCondition() {
      return this.param.ramStepCd === 'RCRS00010'
        && this.process.estimationFlag === 'N'
        && this.process.ramProcessAssessStepCd !== 'RPA0000005'
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.charm.scenario.estimation.url
      this.saveUrl = transactionConfig.ram.charm.scenario.estimation.url
      this.resultUpdateUrl = transactionConfig.ram.assessProcess.estimation.url;
      // code setting
      
      this.$comm.getMultiComboItems(['MALEFICENCE_TYPE'
        , 'CLOSED_VENTILATION'
        , 'MALEFICENCE_GRADE'
        , 'MALEFICENCE_FORM'
        , 'HR_CODE_GRADE'
        , 'VOLUME_UNIT']).then(_result => {
        this.volumnItems = _result['VOLUME_UNIT']
        this.grid.columns = [
          {
            name: 'materialName',
            field: 'materialName',
            label: '화학자재',
            align: 'left',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'chemName',
            field: 'chemName',
            label: '구성물질',
            align: 'left',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'casNo',
            field: 'casNo',
            label: 'CAS No.',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'riskEstimation',
            field: 'riskEstimation',
            label: '위험도 추정',
            align: 'center',
            style: 'width:50px',
            sortable: false,
            color: '#1976D2'
          },
          {
            name: 'exposureLevelFinal',
            field: 'exposureLevelFinal',
            label: '최종노출수준',
            align: 'center',
            style: 'width:40px',
            sortable: false,
            color: '#1976D2'
          },
          {
            name: 'toxic',
            field: 'toxic',
            label: '유해성',
            align: 'center',
            style: 'width:60px',
            sortable: false,
            color: '#1976D2'
          },
          {
            name: 'f',
            field: 'f',
            label: '노출수준 측정',
            child: [
              {
                name: 'suspectUserFlag',
                field: 'suspectUserFlag',
                label: '유소견자 발생여부',
                align: 'center',
                style: 'width:70px',
                sortable: false,
                type: 'check',
                true: 'Y',
                false: 'N'
              },
              {
                name: 'workMeasure',
                field: 'workMeasure',
                label: '작업환경측정',
                child: [
                  {
                    name: 'measValue',
                    field: 'measValue',
                    label: '측정치(A)',
                    align: 'right',
                    style: 'width:80px',
                    sortable: false,
                    type: 'number'
                  },
                  {
                    name: 'exposureStandard',
                    field: 'exposureStandard',
                    label: '노출기준(B)',
                    align: 'right',
                    style: 'width:80px',
                    sortable: false,
                    type: 'number'
                  },
                  {
                    name: 'exposureMeasValue',
                    field: 'exposureMeasValue',
                    label: 'A/B(%)',
                    align: 'right',
                    style: 'width:65px',
                    sortable: false,
                    type: 'cost'
                  },
                ]
              },
              {
                name: 'daily',
                field: 'daily',
                label: '하루 취급량, 비산성/휘발성, 밀폐·환기상태',
                child: [
                  // {
                  //   name: 'limitRepval',
                  //   field: 'limitRepval',
                  //   label: '함유량',
                  //   align: 'center',
                  //   style: 'width:60px',
                  //   sortable: false,
                  //   type: 'number'
                  // },
                  {
                    name: 'dailyVolume',
                    field: 'dailyVolume',
                    label: '일취급량',
                    align: 'right',
                    style: 'width:70px',
                    sortable: false,
                    type: 'number'
                  },
                  {
                    name: 'volumeUnit',
                    field: 'volumeUnit',
                    label: '단위',
                    align: 'center',
                    style: 'width:80px',
                    sortable: false,
                    type: 'select',
                    comboItems: this.volumnItems
                  },
                  {
                    name: 'dailyLevel',
                    field: 'dailyLevel',
                    label: '일취급 수준',
                    align: 'center',
                    style: 'width:50px',
                    sortable: false,
                  },
                  {
                    name: 'temperature',
                    field: 'temperature',
                    label: '사용온도',
                    align: 'right',
                    style: 'width:80px',
                    type: 'number',
                    sortable: false,
                  },
                  {
                    name: 'maleficenceType',
                    field: 'maleficenceType',
                    label: '발생형태',
                    align: 'center',
                    style: 'width:80px',
                    sortable: false,
                    type: 'select',
                    comboItems: _result['MALEFICENCE_TYPE']
                  },
                  {
                    name: 'maleficenceGrade',
                    field: 'maleficenceGrade',
                    label: '비산성',
                    align: 'center',
                    style: 'width:80px',
                    sortable: false,
                    disableTarget: 'maleficenceType',
                    disableCon: 'MT00000001',
                    type: 'select',
                    comboItems: _result['MALEFICENCE_GRADE']
                  },
                  {
                    name: 'boilingPoint',
                    field: 'boilingPoint',
                    label: '끓는점',
                    align: 'right',
                    style: 'width:60px',
                    sortable: false,
                    type: 'number',
                    disableTarget: 'maleficenceType',
                    disableCon: 'MT00000002',
                  },
                  {
                    name: 'volatilityGradeName',
                    field: 'volatilityGradeName',
                    label: '휘발성',
                    align: 'center',
                    style: 'width:60px',
                    sortable: false,
                  },
                  {
                    name: 'exposureLevelCombination',
                    field: 'exposureLevelCombination',
                    label: '노출수준',
                    align: 'center',
                    style: 'width:40px',
                    sortable: false,
                  },
                  {
                    name: 'closedVentilation',
                    field: 'closedVentilation',
                    label: '밀폐·환기상태',
                    align: 'center',
                    style: 'width:100px',
                    sortable: false,
                    type: 'select',
                    none: 'none',
                    comboItems: _result['CLOSED_VENTILATION']
                  },
                ],
              },
            ]
          },
          {
            name: 's',
            field: 's',
            label: '유해성 측정',
            child: [
              {
                name: 'cmrFlag',
                field: 'cmrFlag',
                label: 'CMR여부',
                align: 'center',
                style: 'width:80px',
                sortable: false,
                type: 'check',
                true: 'Y',
                false: 'N'
              },
              {
                name: 'measureCheck',
                field: 'measureCheck',
                label: '노출기준확인',
                child: [
                  {
                    name: 'maleficenceForm',
                    field: 'maleficenceForm',
                    label: '발생형태',
                    align: 'center',
                    style: 'width:110px',
                    sortable: false,
                    disableTarget: 'cmrFlag',
                    disableCon: 'N',
                    type: 'select',
                    comboItems: _result['MALEFICENCE_FORM']
                  },
                  {
                    name: 'maleficenceValue',
                    field: 'maleficenceValue',
                    label: '측정값',
                    align: 'right',
                    style: 'width:80px',
                    sortable: false,
                    disableTarget: 'cmrFlag',
                    disableCon: 'N',
                    type: 'number'
                  },
                ]
              },
              {
                name: 'hrCodeGrade',
                field: 'hrCodeGrade',
                label: '위험문구/유해·위험문구',
                align: 'center',
                style: 'width:80px',
                sortable: false,
                disableTarget: 'cmrFlag',
                disableCon: 'N',
                type: 'select',
                comboItems: _result['HR_CODE_GRADE']
              },
            ]
          },
        ]
      });
      // list setting
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,
        processCd: this.process.processCd,
      }
      this.$http.request((_result) => {
        this.process.charmEstimationScenarios = _result.data;
      },);
    },
    tableDataChange(props, col) {
      if (col.name === 'temperature') {
        if (props.row[col.name]) {
          // 공정사용온도가 있는 경우
          if (props.row.boilingPoint) {
            // 끓는점이 있는 경우 : 공정사용온도는 필수 체크후 넘어왔음으로 있다고 판단
            // 상온 여부 체크
            if (props.row.temperature !== 20) {
              this.$set(props.row, 'volatilityGrade', props.row.boilingPoint < (props.row.temperature*2 + 10) ? '3' :
                props.row.boilingPoint >= (props.row.temperature*2 + 10) && props.row.boilingPoint <= (props.row.temperature*5 + 50) ? '2' : '1')
            } else {
              this.$set(props.row, 'volatilityGrade', props.row.boilingPoint < 50 ? '3' :
                props.row.boilingPoint >= 50 && props.row.boilingPoint <= 150 ? '2' : '1')
            }
            this.$set(props.row, 'volatilityGradeName', props.row.volatilityGrade === '3' ? '3(고)' : 
              props.row.volatilityGrade === '2' ? '2(중)' : '1(저)')
          } else {
            // 노출기준 초기화 처리
            this.$set(props.row, 'volatilityGrade', '0')
            this.$set(props.row, 'volatilityGradeName', '')
          }
        } else {
          // 공정사용온도가 없는 경우
          // 노출기준 초기화 처리
          this.$set(props.row, 'volatilityGrade', '0')
          this.$set(props.row, 'volatilityGradeName', '')
        }
      } else if (col.name === 'maleficenceType') {
        if (props.row[col.name] === 'MT00000002') {
          this.$set(props.row, 'maleficenceGrade', null)
          if (props.row.temperature) {
            if (props.row.boilingPoint) {
              // 끓는점이 있는 경우 : 공정사용온도는 필수 체크후 넘어왔음으로 있다고 판단
              // 상온 여부 체크
              if (props.row.temperature !== 20) {
                this.$set(props.row, 'volatilityGrade', props.row.boilingPoint < (props.row.temperature*2 + 10) ? '3' :
                  props.row.boilingPoint >= (props.row.temperature*2 + 10) && props.row.boilingPoint <= (props.row.temperature*5 + 50) ? '2' : '1')
              } else {
                this.$set(props.row, 'volatilityGrade', props.row.boilingPoint < 50 ? '3' :
                  props.row.boilingPoint >= 50 && props.row.boilingPoint <= 150 ? '2' : '1')
              }
              this.$set(props.row, 'volatilityGradeName', props.row.volatilityGrade === '3' ? '3(고)' : 
                props.row.volatilityGrade === '2' ? '2(중)' : '1(저)')
            } else {
              // 노출기준 초기화 처리
              this.$set(props.row, 'volatilityGrade', '0')
              this.$set(props.row, 'volatilityGradeName', '')
            }
          } else {
            // 노출기준 초기화 처리
            this.$set(props.row, 'volatilityGrade', '0')
            this.$set(props.row, 'volatilityGradeName', '')
          }
        }
      } else if (col.name === 'boilingPoint') {
        // 끓는점 데이터가 들어온 경우
        // 공정사용온도는 필수 체크후 넘어왔음으로 있다고 판단
        // 상온 여부 체크
        if (props.row.temperature) {
          if (props.row[col.name]) {
            if (props.row.temperature !== 20) {
              this.$set(props.row, 'volatilityGrade', props.row.boilingPoint < (props.row.temperature*2 + 10) ? '3' :
                props.row.boilingPoint >= (props.row.temperature*2 + 10) && props.row.boilingPoint <= (props.row.temperature*5 + 50) ? '2' : '1')
            } else {
              this.$set(props.row, 'volatilityGrade', props.row.boilingPoint < 50 ? '3' :
                props.row.boilingPoint >= 50 && props.row.boilingPoint <= 150 ? '2' : '1')
            }
            this.$set(props.row, 'volatilityGradeName', props.row.volatilityGrade === '3' ? '3(고)' : 
              props.row.volatilityGrade === '2' ? '2(중)' : '1(저)')

          } else {
            this.$set(props.row, 'volatilityGrade', '0')
            this.$set(props.row, 'volatilityGradeName', '')
          }
        } else {
          // 노출기준 초기화 처리
          this.$set(props.row, 'volatilityGrade', '0')
          this.$set(props.row, 'volatilityGradeName', '')
        }
      } else if (col.name === 'measValue' || col.name === 'exposureStandard') {
        /**
         * 작업환경측정 :: 해당 부분은 업체를 통해 측정값을 받아 계산하는 로직이 들어가며
         *                기본적으로 해당 측정치를 사용자가 마음대로 바꾸는것은 안됨
         *                LNF 및 솔루션에서는 작업환경측정 데이터가 안 들어올 수 있다는 가정하에 입력을 받게 처리
         */
        this.$set(props.row, 'exposureMeasValue', 
          (props.row.exposureStandard && !isNaN(props.row.exposureStandard) && Number(props.row.exposureStandard) !== 0) ? 
            (props.row.measValue && !isNaN(props.row.measValue) ? 
              Number(props.row.measValue) : 0) * 100 / Number(props.row.exposureStandard) 
            : 0)
      } else if (col.name === 'dailyVolume' || col.name === 'volumeUnit') {
        if (props.row.volumeUnit && props.row.dailyVolume && !isNaN(props.row.dailyVolume)) {
          // let chemprod = this.$_.find(this.process.charmResultScenarios, { mdmChemMaterialId: props.row.mdmChemMaterialId });
          let _dailyVolume = this.$_.clone(props.row.dailyVolume) // this.$_.round(Number(chemprod.dailyVolume) * (Number(props.row.limitRepval) / 100), 4); // 물질의 일취급량
          // let _volumeObj = this.$_.find(this.volumnItems, { code: chemprod.volumeUnit });
          let _volumeUnit = this.$_.clone(props.row.volumeUnit) // _volumeObj.code;
          let _volumeUnitName = this.$_.find(this.volumnItems, { code: props.row.volumeUnit }).codeName // _volumeObj.codeName;
          switch(_volumeUnit) {
            case '1': // g, ㎖
              if (_dailyVolume >= 1000 && _dailyVolume < 1000000) {
                _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
                _volumeUnit = '2';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '2' }).codeName;
              } else if (_dailyVolume >= 1000000) {
                _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
                _volumeUnit = '3';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '3' }).codeName;
              }
              break;
            // case '4': // g, ㎖
            //   if (_dailyVolume >= 1000 && _dailyVolume < 1000000) {
            //     _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
            //     _volumeUnit = '5';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '5' }).codeName;
            //   } else if (_dailyVolume >= 1000000) {
            //     _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
            //     _volumeUnit = '6';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '6' }).codeName;
            //   }
            //   break;
            case '2': // ㎏, ℓ
              if (_dailyVolume >= 1000) {
                _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
                _volumeUnit = '3';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '3' }).codeName;
              } else if (_dailyVolume < 1) {
                _dailyVolume = this.$_.round(_dailyVolume * 1000, 2)
                _volumeUnit = '1';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '1' }).codeName;
              }
              break;
            // case '5': // ㎏, ℓ
            //   if (_dailyVolume >= 1000) {
            //     _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
            //     _volumeUnit = '6';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '6' }).codeName;
            //   } else if (_dailyVolume < 1) {
            //     _dailyVolume = this.$_.round(_dailyVolume * 1000, 2)
            //     _volumeUnit = '4';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '4' }).codeName;
            //   }
            //   break;
            case '3': // ton, ㎥
              if (_dailyVolume < 1 && _dailyVolume >= 0.001) {
                _dailyVolume = this.$_.round(_dailyVolume * 1000, 2)
                _volumeUnit = '2';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '2' }).codeName;
              } else if (_dailyVolume < 0.001) {
                _dailyVolume = this.$_.round(_dailyVolume * 1000 * 1000, 2)
                _volumeUnit = '1';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '1' }).codeName;
              }
              break;
            // case '6': // ton, ㎥
            //   if (_dailyVolume < 1 && _dailyVolume >= 0.001) {
            //     _dailyVolume = this.$_.round(_dailyVolume * 1000, 2)
            //     _volumeUnit = '5';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '5' }).codeName;
            //   } else if (_dailyVolume < 0.001) {
            //     _dailyVolume = this.$_.round(_dailyVolume * 1000 * 1000, 2)
            //     _volumeUnit = '4';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '4' }).codeName;
            //   }
            //   break;
          }
          this.$set(props.row, 'dailyVolume', _dailyVolume)
          this.$set(props.row, 'volumeUnit', _volumeUnit)
          this.$set(props.row, 'volumeUnitName', _volumeUnitName)
          this.$set(props.row, 'dailyLevel', _volumeUnit)
        } else {
          this.$set(props.row, 'dailyLevel', '')
        }
      } else if (col.name === 'limitRepval') {
        /**
         * 함유량 :: 화학자재 마스터에서 관리하는 구성성분의 함유량을 토대로 일취급수준을 결정
         *          단 함유량 대표값을 정확히 판단하기 어려운 경우를 위해 key-in이 되도록 설정
         */
        if (props.row.limitRepval && !isNaN(props.row.limitRepval)) {
          let chemprod = this.$_.find(this.process.charmResultScenarios, { mdmChemMaterialId: props.row.mdmChemMaterialId });
          let _dailyVolume = this.$_.round(Number(chemprod.dailyVolume) * (Number(props.row.limitRepval) / 100), 4); // 물질의 일취급량
          let _volumeObj = this.$_.find(this.volumnItems, { code: chemprod.volumeUnit });
          let _volumeUnit = _volumeObj.code;
          let _volumeUnitName = _volumeObj.codeName;
          switch(chemprod.volumeUnit) {
            case '1': // g, ㎖
              if (_dailyVolume >= 1000 && _dailyVolume < 1000000) {
                _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
                _volumeUnit = '2';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '2' }).codeName;
              } else if (_dailyVolume >= 1000000) {
                _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
                _volumeUnit = '3';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '3' }).codeName;
              }
              break;
            // case '4': // g, ㎖
            //   if (_dailyVolume >= 1000 && _dailyVolume < 1000000) {
            //     _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
            //     _volumeUnit = '5';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '5' }).codeName;
            //   } else if (_dailyVolume >= 1000000) {
            //     _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
            //     _volumeUnit = '6';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '6' }).codeName;
            //   }
            //   break;
            case '2': // ㎏, ℓ
              if (_dailyVolume >= 1000) {
                _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
                _volumeUnit = '3';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '3' }).codeName;
              } else if (_dailyVolume < 1) {
                _dailyVolume = this.$_.round(_dailyVolume * 1000, 2)
                _volumeUnit = '1';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '1' }).codeName;
              }
              break;
            // case '5': // ㎏, ℓ
            //   if (_dailyVolume >= 1000) {
            //     _dailyVolume = this.$_.round(_dailyVolume / 1000, 2)
            //     _volumeUnit = '6';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '6' }).codeName;
            //   } else if (_dailyVolume < 1) {
            //     _dailyVolume = this.$_.round(_dailyVolume * 1000, 2)
            //     _volumeUnit = '4';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '4' }).codeName;
            //   }
            //   break;
            case '3': // ton, ㎥
              if (_dailyVolume < 1 && _dailyVolume >= 0.001) {
                _dailyVolume = this.$_.round(_dailyVolume * 1000, 2)
                _volumeUnit = '2';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '2' }).codeName;
              } else if (_dailyVolume < 0.001) {
                _dailyVolume = this.$_.round(_dailyVolume * 1000 * 1000, 2)
                _volumeUnit = '1';
                _volumeUnitName = this.$_.find(this.volumnItems, { code: '1' }).codeName;
              }
              break;
            // case '6': // ton, ㎥
            //   if (_dailyVolume < 1 && _dailyVolume >= 0.001) {
            //     _dailyVolume = this.$_.round(_dailyVolume * 1000, 2)
            //     _volumeUnit = '5';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '5' }).codeName;
            //   } else if (_dailyVolume < 0.001) {
            //     _dailyVolume = this.$_.round(_dailyVolume * 1000 * 1000, 2)
            //     _volumeUnit = '4';
            //     _volumeUnitName = this.$_.find(this.volumnItems, { code: '4' }).codeName;
            //   }
            //   break;
          }
          this.$set(props.row, 'dailyVolume', _dailyVolume)
          this.$set(props.row, 'volumeUnit', _volumeUnit)
          this.$set(props.row, 'volumeUnitName', _volumeUnitName)
          this.$set(props.row, 'dailyLevel', _volumeUnit)
        } else {
          this.$set(props.row, 'dailyVolume', 0)
          this.$set(props.row, 'volumeUnit', null)
          this.$set(props.row, 'volumeUnitName', null)
          this.$set(props.row, 'dailyLevel', '0')
        }
      }
      
      this.riskEstimationCheck(props)
    },
    riskEstimationCheck(props) {
      let isClosedVentilation = false;
      // 노출 기준 측정
      if (props.row.suspectUserFlag === 'Y') {
        // 1. 유소견자가 있는 경우
        this.$set(props.row, 'exposureLevelCombination', '4')
      } else if (props.row.exposureMeasValue && !isNaN(props.row.exposureMeasValue) && Number(props.row.exposureMeasValue) !== 0) {
        // 2. 작업환경측정 정보가 있는 경우
        let num = Number(props.row.exposureMeasValue)
        this.$set(props.row, 'exposureLevelCombination', num > 100 ? '4' :
          num > 50 && num <= 100 ? '3' :
          num > 10 && num <= 50 ? '2' : '1')
      } else {
        isClosedVentilation = true;
        // 3. 비산성 / 휘발성 체크
        if (props.row['maleficenceType'] === 'MT00000001') {
          if (props.row.dailyLevel === '3') {
            this.$set(props.row, 'exposureLevelCombination', props.row.maleficenceGrade === '3' ? '4' : 
              props.row.maleficenceGrade === '2' ? '4' : 
              props.row.maleficenceGrade === '1' ? '2' : '0')
          } else if (props.row.dailyLevel === '2') {
            this.$set(props.row, 'exposureLevelCombination', props.row.maleficenceGrade === '3' ? '3' : 
              props.row.maleficenceGrade === '2' ? '3' : 
              props.row.maleficenceGrade === '1' ? '2' : '0')
          } else if (props.row.dailyLevel === '1') {
            this.$set(props.row, 'exposureLevelCombination', props.row.maleficenceGrade === '3' ? '2' : 
              props.row.maleficenceGrade === '2' ? '1' : 
              props.row.maleficenceGrade === '1' ? '1' : '0')
          } else {
            this.$set(props.row, 'exposureLevelCombination', '0')
          }
        } else if (props.row['maleficenceType'] === 'MT00000002') {          
          if (props.row.dailyLevel === '3') {
            this.$set(props.row, 'exposureLevelCombination', props.row.volatilityGrade === '3' ? '4' : 
              props.row.volatilityGrade === '2' ? '3' : 
              props.row.volatilityGrade === '1' ? '2' : '0')
          } else if (props.row.dailyLevel === '2') {
            this.$set(props.row, 'exposureLevelCombination', props.row.volatilityGrade === '3' ? '3' : 
              props.row.volatilityGrade === '2' ? '3' : 
              props.row.volatilityGrade === '1' ? '2' : '0')
          } else if (props.row.dailyLevel === '1') {
            this.$set(props.row, 'exposureLevelCombination', props.row.volatilityGrade === '3' ? '2' : 
              props.row.volatilityGrade === '2' ? '2' : 
              props.row.volatilityGrade === '1' ? '1' : '0')
          } else {
            this.$set(props.row, 'exposureLevelCombination', '0')
          }
        } else {
          // 선택되지 않은 경우
          this.$set(props.row, 'exposureLevelCombination', '0')
        }
      }
      this.$set(props.row, 'exposureLevelFinal', String(Number(props.row.exposureLevelCombination) - (isClosedVentilation && Number(props.row.exposureLevelCombination) > 0 ? Number(props.row.closedVentilation) : 0)))

      // 유해성 측정
      if (props.row.cmrFlag === 'Y') {
        // 1. CMR 물질 여부
        this.$set(props.row, 'toxic', '4')
      } else if (props.row.maleficenceValue && props.row.maleficenceForm) {
        // 2. 발생형태에 따른 측정값 체크
        /**
         * 노출값 체크
         * 10㎎/㎥(분진) 또는 500ppm(증기)을 초과 여부
         */
        let checkVal = props.row.maleficenceForm === '분진' ? props.row.maleficenceValue <= 10 : props.row.maleficenceValue <= 500
        if (checkVal) {
          let toxic = function(maleficenceValue, constVal) {
            return maleficenceValue <= 0.01*constVal ? '4' :
              maleficenceValue > 0.01*constVal && maleficenceValue <= 0.1*constVal ? '3' :
              maleficenceValue > 0.1*constVal && maleficenceValue <= 1*constVal ? '2' : '1'
          }
          this.$set(props.row, 'toxic', (props.row.maleficenceForm === '분진' ? toxic(props.row.maleficenceValue, 1) : toxic(props.row.maleficenceValue, 50)))
        } else {
          // 초과한 경우 유해위험문구를 체크
          this.$set(props.row, 'toxic', (props.row.hrCodeGrade ? props.row.hrCodeGrade : '0'))
        }
      } else {
        // 유해위험문구
        this.$set(props.row, 'toxic', (props.row.hrCodeGrade ? props.row.hrCodeGrade : '0'))
      }
      // 위험도 추정
      this.$set(props.row, 'riskEstimation', String((props.row.exposureLevelFinal && !isNaN(props.row.exposureLevelFinal) ? Number(props.row.exposureLevelFinal) : 0) * (props.row.toxic && !isNaN(props.row.toxic) ? Number(props.row.toxic) : 0)))
    },
    research() {
      this.$emit('research', 'scenario')
    },
    /* eslint-disable no-unused-vars */
    saveScenario() {
      if (this.$comm.validTable(this.grid.columns, this.process.charmEstimationScenarios)) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {            
            this.isSave = !this.isSave
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveScenarioCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.research();
      this.getList();

      if (this.estimationUpdateBtnData.flag) {
        this.$http.url = this.resultUpdateUrl
        this.$http.type = 'PUT';
        this.$http.param = {
          ramRiskAssessmentPlanId: this.process.ramRiskAssessmentPlanId,
          processCd: this.process.processCd,
        };
        this.$http.request((_result) => {
          this.estimationUpdateBtnData.research = uid();
        },);
      }
    },
    /**
     * 재조회
     * 목적 : 돌아가기전 데이터를 저장 했을 수도 있지만 
     *        입력만 하고 돌아가는 경우를 대비하기 위함
     */
    back() {
      this.research();
      this.getList();
    },
  }
};
</script>
<style lang="sass">
.scenario-chip i 
  margin-right: -0.2em !important
</style>
